import {
  IconButton,
  styled,
  Tooltip as MUITooltip,
  tooltipClasses,
  TooltipProps,
} from "@mui/material";

import CloseIcon from "@/assets/icons/close-bold.svg?react";

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <MUITooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  zIndex: 1300,
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: "264px",
    minWidth: "200px",
    marginRight: "16px",
    padding: "8px 34px 8px 10px",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "18px",
    letterSpacing: "0.2px",
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    borderRadius: "10px",
    boxShadow: "0px 16px 16px 0px #00000029, 0px 0px 8px 0px #0000001F",
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.primary.main,
    },
  },
  [`& .${tooltipClasses.tooltipPlacementBottom}`]: {
    marginTop: "8px !important",
  },
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  top: "9px",
  right: "11px",
  backgroundColor: theme.palette.common.white,
  ":hover": {
    backgroundColor: theme.palette.common.white,
  },
  "& svg": {
    color: theme.palette.primary.main,
  },
}));

interface IProps extends TooltipProps {
  children: React.ReactElement;
}

const Tooltip = ({ onClose, title, children, ...props }: IProps) => {
  return (
    <StyledTooltip
      arrow
      title={
        <>
          {title}
          <StyledIconButton size="small" onClick={onClose}>
            <CloseIcon width={6} height={6} />
          </StyledIconButton>
        </>
      }
      disableFocusListener
      disableHoverListener
      disableTouchListener
      slotProps={{
        popper: {
          disablePortal: true,
        },
      }}
      {...props}
    >
      {children}
    </StyledTooltip>
  );
};

export default Tooltip;
